<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xMu8K4/tc-custom/9781627887908.jpg?1702591853356" alt="This image is the cover for the book KetoDiet Cookbook"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">KetoDiet Cookbook
      </h1>
      <p class="bookDescription body article font2">
        <p>More than just a standard cookbook, The KetoDiet Cookbook gives you the science behind why keto makes you lose weight and build muscle, in addition to 150 recipes. You love your Paleo or low-carb diet, but is it enough to give your metabolism the jolt it needs to really burn off that extra weight and live a healthier life? By eating foods higher in good fats, moderate protein, and little-to-no carbohydrates, you'll feel less hungry. Not only that, but your body begins to burn fats stores instead of the carbohydrates and glucose that usually bog down your system.The KetoDiet Cookbook contains 150 recipes and practical information for living and adhering to a ketogenic lifestyle. Martina Slajerova, founder of the KetoDiet blog, provides a complete guide to the ketogenic diet based on the most recent research. Discover the science behind the ketogenic diet and the abundant practical solutions that benefit both beginners and advanced keto-dieters.Indulge in 150 recipes created to be perfectly compatible with ketogenic, low-carb, high-fat, gluten-free, grain free, Paleo, primal, and ancestral diets.Recipes featured in The KetoDiet Cookbook are totally free of:   ·Grain   ·Sugar   ·Potatoes   ·Legumes   ·Additives/Artificial sweeteners   ·Unhealthy oils/fatsDairy-free options are also included. With soups, breakfasts, appetizers, sides, and sauces, you'll be enjoying delicious meals while giving your body the boost it deserves!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martina Slajerova
      </h2>
      
      <p class="authorDescription body article">Martina Slajerova is a health and food blogger living in the United Kingdom. She is the best-selling author of The KetoDiet Cookbook, Sweet and Savory Fat Bombs, Beginner’s KetoDiet Cookbook, Quick Keto Meals in 30 Minutes or Less, Keto Slow Cooker & One-Pot Meals, The Keto All Day Cookbook, Super Low-Carb Snacks, and Keto Simple. A firm believer in low-carb living, Martina discovered the ketogenic diet after being diagnosed with Hashimoto’s Disease in 2011. Frustrated with the lack of practical resources, Martina created the KetoDiet app and blog to help others live the ketogenic lifestyle successfully. A science geek at heart, Martina incorporates the latest research as well as firsthand experience into her advice. When creating recipes, she focuses not just on carb count, but on creating delicious, healthy recipes that are free of processed ingredients, unhealthy vegetable oils, and artificial sweeteners. Today her blog posts reach hundreds of thousands of people and her work has been featured in Cosmopolitan, Glamour, Huffpost Healthy Living, BuzzFeed, as well as dozens of other low-carb media and outlets.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fair Winds Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?675b7f4d